<div class="card border rounded-4">
  <div class="card-body">
    <form [formGroup]="form" (ngSubmit)="onSave()">
      <div class="row gx-md-5">
        <div [class]="isEdit() ? 'col-lg-12' : 'col-lg-6 border-end'">
          <div class="d-flex align-items-center gap-2 mb-4">
            <h3 class="mb-0">
              <i class="bi bi-layout-text-window me-1"></i>
              Overview
            </h3>
            @if (isGlobal()) {
              <span class="text-muted small">(This is a global product and will have an effect on all Elevations)</span>
            }
          </div>
          @if (!isEdit()) {
            <div class="row mb-3">
              <div class="col-md-9">
                <generic-dropdown
                  [items]="elevationsDisplay()"
                  [label]="'Elevation'"
                  [multiselect]="true"
                  [allowSearch]="true"
                  [clearable]="true"
                  [placeholder]="'Select'"
                  [required]="true"
                  formControlName="selectedElevationIds"
                >
                </generic-dropdown>
                @if (form.get('selectedElevationIds')?.touched && form.get('selectedElevationIds')?.invalid) {
                  <small class="text-danger position-absolute">Elevation is required</small>
                }
              </div>
              <div class="col-auto align-self-end">
                <div class="form-check form-switch">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="selectAllElevations"
                    formControlName="selectAllElevations"
                  />
                  <label class="form-check-label" for="selectAllElevations">Select all elevations</label>
                </div>
              </div>
            </div>
          }

          <div class="row mb-3">
            <div class="col-12 col-md-9 mb-3">
              <generic-dropdown
                [items]="productTypesDisplay()"
                [label]="'Product Type'"
                [allowSearch]="true"
                [clearable]="true"
                [placeholder]="'Select'"
                [required]="true"
                formControlName="selectedProductTypeId"
              >
              </generic-dropdown>
              @if (
                form.get('selectedProductTypeId')?.touched && form.get('selectedProductTypeId')?.hasError('required')
              ) {
                <small class="text-danger">Product Type is required</small>
              }
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-12 col-md-9 mb-3">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="overrideSalesDescription"
                  formControlName="overrideSalesDescription"
                  (change)="onOverrideToggleChange()"
                />
                <label class="form-check-label" for="overrideSalesDescription">Override Sales Description</label>
              </div>
            </div>
            <div class="col-12 col-md-9 mb-3">
              <input-field
                [type]="'text'"
                [label]="'Sales Description'"
                placeholder="Enter"
                formControlName="salesDescription"
              >
              </input-field>
            </div>
          </div>

          @if (isEdit()) {
            <div class="align-items-center d-flex gap-3 justify-content-end mt-4">
              <div class="d-flex gap-2">
                <button type="button" class="btn btn-outline-secondary btn-h42" (click)="onCancel()">Cancel</button>
                <button type="submit" class="btn btn-primary btn-h42">Update</button>
              </div>
            </div>
          }
        </div>
        @if (!isEdit()) {
          <div class="col-lg-6">
            <div class="d-flex align-items-center gap-3 mb-3">
              <i class="bi bi-cash fs-20"></i>
              <h3 class="mb-0">Current Selling Price</h3>
            </div>
            <div class="row">
              <div class="col-12 col-md-4 mb-3">
                <label class="form-label">Effective Date</label>
                <p-datepicker
                  showIcon
                  styleClass="w-100"
                  dateFormat="yy-mm-dd"
                  placeholder="Select Date"
                  formControlName="effectiveDate"
                >
                </p-datepicker>
              </div>
              <div class="col-12 col-md-4 mb-3">
                <!-- <label class="form-label">Quantity <span class="text-danger">*</span></label> -->
                <input-field
                  [type]="'number'"
                  [requiredLabel]="true"
                  [label]="'Quantity'"
                  placeholder="Enter"
                  [min]="0"
                  formControlName="quantity"
                  [errormessage]="'Quantity is required'"
                >
                </input-field>
                <!-- @if (form.get('quantity')?.touched && form.get('quantity')?.hasError('required')) {
                  <small class="text-danger">Quantity is required</small>
                } @else if (form.get('quantity')?.touched && form.get('quantity')?.hasError('min')) {
                  <small class="text-danger">Quantity cannot be negative</small>
                } -->
              </div>
              <div class="col-12 col-md-4 mb-3">
                <currency-input-field
                  [label]="'Unit Price'"
                  [placeholder]="'Enter'"
                  [requiredLabel]="true"
                  formControlName="unitPrice"
                  [control]="form.get('unitPrice')"
                  [min]="0"
                  [errormessage]="'Unit Price is required error from parent'"
                ></currency-input-field>
                <!-- @if (form.get('unitPrice')?.touched && form.get('unitPrice')?.hasError('required')) {
                  <small class="text-danger">Unit Price is required</small>
                } @else if (form.get('unitPrice')?.touched && form.get('unitPrice')?.hasError('min')) {
                  <small class="text-danger">Unit Price cannot be negative</small>
                } -->
              </div>

              <div class="col-12 col-md-4 mb-3">
                <currency-input-field
                  [label]="'Retail Credit'"
                  [placeholder]="'Enter'"
                  formControlName="retailCredit"
                  [control]="form.get('retailCredit')"
                  [min]="0"
                ></currency-input-field>
                <!-- @if (form.get('retailCredit')?.touched && form.get('retailCredit')?.hasError('min')) {
                  <small class="text-danger">Retail Credit cannot be negative</small>
                } -->
              </div>
              <div class="col-12 col-md-4 align-self-center">
                <label class="form-label">Amount</label>
                <div class="text-success fw-600 fs-20">{{ amount() | currencyFormat }}</div>
              </div>
            </div>

            <div class="align-items-center d-flex gap-3 justify-content-end mt-4">
              <div>
                @if (shouldShowOverwriteExisting()) {
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="overwriteExisting"
                      formControlName="overwriteExisting"
                    />
                    <label class="form-check-label" for="overwriteExisting">Override existing data</label>
                  </div>
                }
              </div>
              <div class="d-flex gap-2">
                <button type="button" class="btn btn-outline-secondary btn-h42" (click)="onCancel()">Cancel</button>
                <button type="submit" class="btn btn-primary btn-h42">{{ isEdit() ? 'Update' : 'Save' }}</button>
              </div>
            </div>
          </div>
        }
      </div>
    </form>
  </div>
</div>
